import React, { useState, useEffect, useContext } from "react";
import { useMutation, ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";

import { Container, Card, CardContent, Typography, makeStyles } from "@material-ui/core";
import Box from "@mui/material/Box";

import Header from "./Header.js";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.2rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
}));

const Settings = () => {
  const classes = useStyles();

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else navigate(`/ie/signin/?next=${pathname}`);
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`/ie/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`/ie/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };

  let email = localStorage.getItem("email") ? localStorage.getItem("email") : null;

  let tenantName = localStorage.getItem("tenantName")
    ? localStorage.getItem("tenantName")
    : null;

  return (
    <div className={classes.root}>
      <Header breadcrumbs={[{ label: "Add Client", link: null }]} />
      <div className={classes.container}>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body1" style={{ marginBottom: 10 }}>
            Under Construction
          </Typography>
        </Box>
      </div>
    </div>
  );
};
export default Settings;
